import { computedAsset, coords, AssetManager } from "./AssetManager";
import { ASSET_TYPE, BearAsset } from "../AssetConst";
import * as THREE from "three/build/three.module.js";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";

import { BuildMediaUrl } from "../../ArgoUtils";
import { MTLLoader } from "three/examples/jsm/loaders/MTLLoader.js";
import { OBJLoader } from "three/examples/jsm/loaders/OBJLoader.js";

enum file3DType {
    fbx = 1,
    obj,
    gltf
}

export class Object3DManager extends AssetManager {
    private fileType: file3DType = file3DType.gltf;
    private isZip = false;
    private LoadingManager = new THREE.LoadingManager();
    private assetCoords: any;
    private asset: BearAsset;

    private fetchFile = (url: string): Promise<any> => {
        return new Promise(function(resolve, reject) {
            fetch(url).then(function(response) {
                if (response.status === 200 || response.status === 0) {
                    resolve(response.blob());
                } else {
                    reject(new Error(response.statusText));
                }
            });
        });
    };

    private loadGLTF = (url: string): Promise<any> => {
        const loader = new GLTFLoader(this.LoadingManager);
        return new Promise(resolve => {
            loader.load(url, gltfObject => {
                const gltfScene = this.setGLTFScene(gltfObject);
                resolve(this.fnComputeAssetObject(gltfScene, this.assetCoords, this.asset));
            });
        });
    };

    private setGLTFScene(gltfObject): any {
        const gltfScene = gltfObject.scene || gltfObject.scenes[0];

        // animate
        if (gltfObject && gltfObject.animations) {
            gltfScene.mixer = new THREE.AnimationMixer(gltfScene);
            gltfScene.animations = gltfObject.animations;

            gltfObject.animations.forEach(animation => {
                const action = gltfScene.mixer.clipAction(animation);
                if (this.asset.is_play_in_loop) {
                    action.setLoop(THREE.LoopRepeat);
                } else {
                    action.setLoop(THREE.LoopOnce);
                }
                action.clampWhenFinished = true;
                action.enable = true;
                // action.play();
            });
        }
        return gltfScene;
    }

    public getComputedAsset = (asset: BearAsset): Promise<THREE.Mesh> => {
        this.asset = asset;
        this.assetCoords = this.fnGetAssetRealCoords(this.asset);

        const url = BuildMediaUrl(
            this.asset.s1 && this.asset.s1 != "" ? this.asset.s1 : this.asset.media_file
        );
        this.isZip = url.match(/\.zip$/) != null;

        if (!this.isZip) {
            //we assume it is gltf
            return this.loadGLTF(url);
        } else return Promise.reject("Cannot handle zip GLTF anymore");
    };
}
